
import { Control, ControlType, KngFilterState } from './definitions/kng-filter-panel.interface';
export class KngFilterPanelFactory 
{
	public static buildState(): KngFilterState 
	{
		return {
			filterData: {
				heading: {
					label: 'Filters'
				},
				sections: [
					{
						label: 'Date Range',
						collapsed: true,
						controls: [
							new Control({
								id: 'acf50332-d71e-4c8f-9c61-4d2349b042e9',
								label: 'uii',
								type: ControlType.radio,
								value: '2022-06-14T00:00:00.000Z 2022-06-14T23:59:59.999Z',
								inputPlaceholderText: '',
								inputIcon: '',
								options: [
									{
										label: 'Last Day',
										value: '2022-06-14T00:00:00.000Z 2022-06-14T23:59:59.999Z',
										checked: true
									},
									{
										label: 'Last 7 Days',
										value: '2022-06-07T00:00:00.000Z 2022-06-14T23:59:59.999Z',
										checked: false
									}
								]
							})
						],
						accordionCollapsedIcon: { iconPath: '', altText: '' },
						accordionExpandedIcon: { iconPath: '', altText: '' },
						searchIcon: { iconPath: '', altText: '' },
						crossIcon: { iconPath: '', altText: '' }
					},
					{
						label: 'Location',
						collapsed: false,
						controls: [
							new Control({
								id: 'a2690769-0405-481d-a630-0ea92f1f73e1',
								label: '',
								type: ControlType.input,
								value: '',
								inputPlaceholderText: 'Search by Location',
								inputIcon:
                  'https://cdn-icons-png.flaticon.com/512/751/751463.png',
								options: []
							}),
							new Control({
								id: 'a333504b-301a-404d-a75c-3b77bb74b975',
								label: '',
								type: ControlType.checkbox,
								value: 'dcf246e3-f059-43c3-a91b-d9739ee695b4',
								inputPlaceholderText: '',
								inputIcon: '',
								options: [
									{
										label: 'Location A',
										description:
                      'Address Line1, Address Line 2, City, State, Postal Code',
										value: 'dcf246e3-f059-43c3-a91b-d9739ee695b4'
									},
									{
										label: 'Location B',
										description:
                      'Address Line1, Address Line 2, City, State, Postal Code',
										value: '98a488d5-dd0f-4bc4-87b8-d4f3ef82beac'
									}
								]
							})
						],
						accordionCollapsedIcon: { iconPath: '', altText: '' },
						accordionExpandedIcon: { iconPath: '', altText: '' },
						searchIcon: { iconPath: '', altText: '' },
						crossIcon: { iconPath: '', altText: '' }
					}
				],
				ctaList: [
					{
						id: '327147f4-c044-4799-8a5a-d075c619e41c',
						label: 'Cancel',
						className: 'light',
						disabled: false
					},
					{
						id: '7eeaa3f0-b4f6-4142-8086-361298d75686',
						label: 'Apply',
						className: 'dark',
						disabled: false
					}
				]
			},
			hidden: true
		};
	}
}
